import { FC, useCallback, useContext, useState } from 'react'

import { NotificationContext } from '../../providers'
import { CustomerEntry } from '../../sdk'
import { ShareViaEmailDialog } from './ShareViaEmailDialog'
import { ShareViaMainDialog } from './ShareViaMainDialog'
import { ShareViaSmsDialog } from './ShareViaSmsDialog'

interface Props {
  title: string
  link: string
  handleClose: () => void
  customer?: CustomerEntry
  regenerateLink?: (showPartsLabor: boolean) => Promise<void>
}

export const ShareViaContainer: FC<Props> = ({
  title,
  link,
  handleClose,
  customer,
  regenerateLink
}) => {
  const { setNotice } = useContext(NotificationContext)

  const defaultMessage =
    'You can access the complete information through this link: ' + link

  const [openShareViaMainDialog, setOpenShareViaMainDialog] =
    useState<boolean>(true)
  const [openShareViaEmailDialog, setOpenShareViaEmailDialog] =
    useState<boolean>(false)
  const [openShareViaSmsDialog, setOpenShareViaSmsDialog] =
    useState<boolean>(false)

  const handleCloseMainDialog = useCallback(async () => {
    setOpenShareViaMainDialog(false)
    handleClose()
  }, [handleClose])

  const handleOpenEmailDialog = useCallback(async () => {
    setOpenShareViaMainDialog(false)
    setOpenShareViaEmailDialog(true)
  }, [])

  const handleCloseEmailDialog = useCallback(async () => {
    setOpenShareViaEmailDialog(false)
    setOpenShareViaMainDialog(true)
  }, [])

  const handleSubmitEmailDialog = useCallback(async () => {
    setOpenShareViaEmailDialog(false)
    handleClose()

    setNotice('Email client opened')
  }, [handleClose, setNotice])

  const handleOpenSmsDialog = useCallback(async () => {
    setOpenShareViaMainDialog(false)
    setOpenShareViaSmsDialog(true)
  }, [])

  const handleCloseSmsDialog = useCallback(async () => {
    setOpenShareViaSmsDialog(false)
    setOpenShareViaMainDialog(true)
  }, [])

  const handleSubmitSmsDialog = useCallback(async () => {
    setOpenShareViaSmsDialog(false)
    handleClose()

    setNotice('SMS successfully sent')
  }, [handleClose, setNotice])

  return (
    <>
      <ShareViaMainDialog
        title={title}
        link={link}
        open={openShareViaMainDialog}
        handleEmail={handleOpenEmailDialog}
        handleSms={handleOpenSmsDialog}
        handleCancel={handleCloseMainDialog}
        regenerateLink={regenerateLink}
      />
      <ShareViaEmailDialog
        defaultMessage={defaultMessage}
        open={openShareViaEmailDialog}
        handleCancel={handleCloseEmailDialog}
        handleSend={handleSubmitEmailDialog}
        customer={customer}
      />
      <ShareViaSmsDialog
        defaultMessage={defaultMessage}
        open={openShareViaSmsDialog}
        handleCancel={handleCloseSmsDialog}
        handleSend={handleSubmitSmsDialog}
        customer={customer}
      />
    </>
  )
}
